<!--  -->
<template>
  <div class="">
    <div class="selsect">
      <el-button
        class="search"
        size="mini"
        type="primary"
        @click="AdminUpdateParentEval(1)"
        :disabled="!checkArr.length"
        >开启</el-button
      >
      <el-button
        class="search"
        size="mini"
        type="danger"
        @click="AdminUpdateParentEval(0)"
        :disabled="!checkArr.length"
        >禁用</el-button
      >
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin: 0 auto"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
        empty-text="暂无数据"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="CateName" label="分类名称" width="180">
        </el-table-column>
        <el-table-column prop="StudyYearName" label="学届" width="180">
        </el-table-column>
        <el-table-column prop="GradeName" label="年级"> </el-table-column>
        <el-table-column prop="ClassName" label="班级"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag plain type="success" v-if="scope.row.Status == 1"
              >开启</el-tag
            >
            <el-tag plain type="info" v-if="scope.row.Status == 0">关闭</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { AdminGetParentEvalByPage, AdminUpdateParentEval } from "../../api/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tableData: [],
      checkArr: [],
      userInfo: {},
      isKindergarten: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    async AdminUpdateParentEval(flag) {
      let pram = {
        type: this.isKindergarten ? 1 : 2,
        status: flag,
        baseInfo: [],
      };
      this.checkArr.forEach((element) => {
        pram.baseInfo.push({
          studyYearId: element.StudyYearId,
          cateId: element.CateId,
          gradeId: element.GradeId,
          classId: element.ClassId,
        });
      });
      let xhr = await AdminUpdateParentEval(pram);
      if (xhr.data.success) {
        this.AdminGetParentEvalByPage();
        this.$message.success("操作成功");
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
    handleSelectionChange(val) {
      this.checkArr = val;
    },
    async AdminGetParentEvalByPage() {
      let xhr = await AdminGetParentEvalByPage({
        PageIndex: 1,
        PageSize: 10000,
      });
      if (xhr.data.success) {
        this.tableData = xhr.data.response;
      }
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    let UserIdentityArr = this.userInfo.UserIdentity.split(";");
    let isKindergarten = UserIdentityArr.find((item) => {
      return item == 1;
    });
    if (isKindergarten) {
      this.isKindergarten = true;
    } else {
      this.isKindergarten = false;
    }
  },
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.AdminGetParentEvalByPage();
  },
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.selsect {
  background-color: #ffffff;
  padding: 20px;
}
.colorBlur {
  color: #a0cfff !important;
}

.btns {
  margin-top: 20px;
  margin-left: 20px;
}

.search {
  margin-left: 30px !important;
}
.table {
  margin: 20px;
}
.paging {
  margin-left: 20px;
  margin-top: 20px;
}
.last_btn {
  margin-left: 20px !important;
}
</style>